import { usePage } from "@inertiajs/react";
import { ReactElement } from "react";

import { useIsCurrentPageInitial } from "hooks/useIsCurrentPageInitial";
import { useIsScreenSizeBiggerThanTailwindSize } from "hooks/useIsScreenSizeBiggerThanTailwindSize";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { DefaultPageType } from "types/DefaultPageType";

import Backlink from "./Backlink";
import LogoLink from "./LogoLink";

const LogoOrBackLink = ({ children }: { children: ReactElement }) => {
  const { pathName } = usePage<DefaultPageType>().props;
  const isPageInitial = useIsCurrentPageInitial();
  const isDesktopVersionActive = useIsScreenSizeBiggerThanTailwindSize("lg");
  const isHomePage = pathName && pathName.includes("/home");
  const isLoggedIn = useIsLoggedIn();
  const shouldLogoLinkBeShown =
    isHomePage || isDesktopVersionActive || isPageInitial;

  if (shouldLogoLinkBeShown && !isLoggedIn) {
    return children;
  }
  if (shouldLogoLinkBeShown && isLoggedIn) {
    return <LogoLink url="/home" />;
  }
  return <Backlink className="pl-2 lg:pl-0" />;
};

export default LogoOrBackLink;
